<template>
  <button
    type="button"
    class="relative bg-cl-transparent brdr-none inline-flex button-cart"
    @click="openMicrocart"
    data-testid="openMicrocart"
    :aria-label="$t('Open microcart')"
  >
    <img src="../../../../assets/cart.svg" width="100" height="100" class="cart-icon" alt="cart" loading="eager" fetchpriority="high">
    <span
      class="minicart-count absolute flex center-xs middle-xs border-box py0 px2 h6 lh16 weight-700 cl-white bg-cl-silver"
      v-cloak
      v-show="totalQuantity"
      data-testid="minicartCount"
    >
      {{ totalQuantity }}
    </span>
  </button>
</template>

<script>
import MicrocartIcon from '@vue-storefront/core/compatibility/components/blocks/Header/MicrocartIcon'

export default {
  mixins: [MicrocartIcon]
}
</script>

<style scoped lang="scss">
.button-cart.icon {
  opacity: 1;
  color: #000;
  &:hover,
  &:focus {
    opacity: 0.8;
  }
}

.minicart-count {
  top: 7px;
  left: 50%;
  min-width: 16px;
  min-height: 16px;
  border-radius: 10px;
}

.cart-icon {
  width: 20px;
  height: 20px;
}
</style>
